module.exports = __webpack_public_path__ + "img/1531773213.2152cecc.jpg";